import { Directive, Input, HostListener, Output, EventEmitter } from '@angular/core';
import { CookiesSettingsType } from '../domain/cookies-settings-type';
import { CookieSettingsService } from './cookie-settings.service';

@Directive({
  selector: '[cookies-check]'
})
/**
 * Directive that checks if cookies are enabled before emiting an event to "onClickAfterCheck" only if cookies required
 * are enabled
 */
export class CookiesCheckDirective {
  @Input() cookiesRequired: CookiesSettingsType[];
  @Output() clickAfterCheck: EventEmitter<boolean> = new EventEmitter();
  @HostListener('click', ['$event'])
  onClick() {
    if (!this.cookiesRequired) return;
    if (this.cookiesService.areCookiesConsentEnabled(this.cookiesRequired)) {
      this.clickAfterCheck.next(true);
    } else {
      this.cookiesService.getCookieConsentInput(this.cookiesRequired).then(enabled => {
        if (enabled) this.clickAfterCheck.next(true);
      });
    }
  }

  constructor(private cookiesService: CookieSettingsService) {}
}
